

import { useState } from 'react';
import PageHeader from '@/components/BrotocolPage/PageHeader';
import PageContent from '@/components/BrotocolPage/PageContent';
import PageOne from '@/components/BrotocolPage/PageOne';
import PageTwo from '@/components/BrotocolPage/PageTwo';
import PageThree from '@/components/BrotocolPage/PageThree';
import PageFour from '@/components/BrotocolPage/PageFour';
import PageFive from '@/components/BrotocolPage/PageFive';
import PageSix from '@/components/BrotocolPage/PageSix';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Brotocol = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 6;

  const getPageContent = (pageNumber: number) => {
    switch (pageNumber) {
      case 1:
        return <PageOne />;
      case 2:
        return <PageTwo />;
      case 3:
        return <PageThree />;
      case 4:
        return <PageFour />;
      case 5:
        return <PageFive />;
      case 6:
        return <PageSix />;
      default:
        return <PageOne />;
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-blue-light to-blue-dark">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <PageHeader />
        
        <div className="bg-card/20 backdrop-blur-sm rounded-lg p-8 mb-8 border border-border/50">
          <PageContent pageNumber={currentPage}>
            {getPageContent(currentPage)}
          </PageContent>
        </div>

        {/* Navigation */}
        <div className="flex justify-between items-center">
          <Button
            onClick={prevPage}
            disabled={currentPage === 1}
            variant="outline"
            className="flex items-center gap-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
          >
            <ChevronLeft className="w-4 h-4" />
            Previous
          </Button>

          <div className="flex space-x-2">
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentPage(i + 1)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  currentPage === i + 1 ? 'bg-primary' : 'bg-primary/30'
                }`}
              />
            ))}
          </div>

          <Button
            onClick={nextPage}
            disabled={currentPage === totalPages}
            variant="outline"
            className="flex items-center gap-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
          >
            Next
            <ChevronRight className="w-4 h-4" />
          </Button>
        </div>

        <div className="text-center mt-4">
          <span className="text-muted-foreground">
            Page {currentPage} of {totalPages}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Brotocol;
